import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import "./about.css";
import { Link, NavLink } from "react-router-dom";
import tours from "../../../datebase/tours";
const About = ({ t, langcat, setScoreTours, scoreTours }) => {

    return (
        <>
            <div className="about">
                <div className="container">
                    <div className="about-flex">
                        <div className="about-box1">
                            <span className="about-box1-img">
                                <iframe src="https://www.youtube.com/embed/aQOapxi0w2U?si=KxfXktZXY1AX_qM4" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>
                            </span>
                            <span className="about-box1-text">
                                Основанная в 2005 году, Besqala и Aral Sea Discovery предлагают эксклюзивные туры по Каракалпакстану и Аральскому морю, раскрывая необычайную красоту и культурное разнообразие этого уникального региона. Наш опыт и знания гарантируют безопасные и запоминающиеся путешествия, ведомые страстными гидами, влюбленными в местные истории и легенды.
                            </span>
                        </div>
                        <div className="about-box2">
                            <div className="about-box2-boxs">
                                <h3>150.000+</h3>
                                <h4>Туристов</h4>
                            </div>
                            <div className="about-box2-boxs">
                                <h3>20+</h3>
                                <h4>Лет опыта</h4>
                            </div>
                            <div className="about-box2-boxs">
                                <h3>25+</h3>
                                <h4>Автомобилей</h4>
                            </div>
                            <div className="about-box2-boxs">
                                <h3>32</h3>
                                <h4>Юрт</h4>
                            </div>
                        </div>
                        <div className="about-box3">
                            <div className="about-box3-boxs left">
                                <div className="about-box3-boxs-textbox">
                                    <h3>{t("aboutboxhistory1.year")}</h3>
                                    <h4>{t("aboutboxhistory1.sub")}</h4>
                                    <h5>{t("aboutboxhistory1.text")}</h5>
                                </div>
                            </div>
                            <div className="about-box3-boxs right">
                                <div className="about-box3-boxs-textbox">
                                    <h3>{t("aboutboxhistory2.year")}</h3>
                                    <h4>{t("aboutboxhistory2.sub")}</h4>
                                    <h5>{t("aboutboxhistory2.text")}</h5>
                                </div>
                            </div>
                            <div className="about-box3-boxs left">
                                <div className="about-box3-boxs-textbox">
                                    <h3>{t("aboutboxhistory3.year")}</h3>
                                    <h4>{t("aboutboxhistory3.sub")}</h4>
                                    <h5>{t("aboutboxhistory3.text")}</h5>
                                </div>
                            </div>
                            <div className="about-box3-boxs right">
                                <div className="about-box3-boxs-textbox">
                                    <h3>{t("aboutboxhistory4.year")}</h3>
                                    <h4>{t("aboutboxhistory4.sub")}</h4>
                                    <h5>{t("aboutboxhistory4.text")}</h5>
                                </div>
                            </div>
                            <div className="about-box3-boxs left">
                                <div className="about-box3-boxs-textbox">
                                    <h3>{t("aboutboxhistory5.year")}</h3>
                                    <h4>{t("aboutboxhistory5.sub")}</h4>
                                    <h5>{t("aboutboxhistory5.text")}</h5>
                                </div>
                            </div>
                            <div className="about-box3-boxs right">
                                <div className="about-box3-boxs-textbox">
                                    <h3>{t("aboutboxhistory6.year")}</h3>
                                    <h4>{t("aboutboxhistory6.sub")}</h4>
                                    <h5>{t("aboutboxhistory6.text")}</h5>
                                </div>
                            </div>
                            <div className="about-box3-boxs left">
                                <div className="about-box3-boxs-textbox">
                                    <h3>{t("aboutboxhistory7.year")}</h3>
                                    <h4>{t("aboutboxhistory7.sub")}</h4>
                                    <h5>{t("aboutboxhistory7.text")}</h5>
                                </div>
                            </div>
                            <div className="about-box3-boxs right">
                                <div className="about-box3-boxs-textbox">
                                    <h3>{t("aboutboxhistory8.year")}</h3>
                                    <h4>{t("aboutboxhistory8.sub")}</h4>
                                    <h5>{t("aboutboxhistory8.text")}</h5>
                                </div>
                            </div>
                            <div className="about-box3-boxs left">
                                <div className="about-box3-boxs-textbox">
                                    <h3>{t("aboutboxhistory9.year")}</h3>
                                    <h4>{t("aboutboxhistory9.sub")}</h4>
                                    <h5>{t("aboutboxhistory9.text")}</h5>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};
export default About;
